export const FETCH_OFFICE_MANAGEMENT_DATA = "FETCH_OFFICE_MANAGEMENT_DATA";
export const UPDATE_OFFICE_MANAGEMENT_DATA = "UPDATE_OFFICE_MANAGEMENT_DATA";

export const SET_OFFICE_MANAGEMENT_DATA = "SET_OFFICE_MANAGEMENT_DATA";
export const FAILURE_OFFICE_MANAGEMENT_DATA = "FAILURE_OFFICE_MANAGEMENT_DATA";
export const SUCCESS_OFFICE_MANAGEMENT_DATA = "SUCCESS_OFFICE_MANAGEMENT_DATA";
export const LOADING_OFFICE_MANAGEMENT_DATA = "LOADING_OFFICE_MANAGEMENT_DATA";
